import Header from 'components/header'
import PurgeQueueDlq from './components/purge-queue-dlq'

const ControlPanel = () => (
  <div className='control-panel-page'>
    <Header title='Control Panel' />
    <PurgeQueueDlq />
  </div>
)

export default ControlPanel
